import { createI18n } from 'vue-i18n';
import messages from '@/utils/locales/messages';

export const SUPPORTED_LOCALES = ['en', 'uk'] as const;
type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const normalizeLocale = (value: string | null): SupportedLocale => {
  if (!value) return 'en';
  if (value === 'ua') return 'uk';

  if (SUPPORTED_LOCALES.includes(value as SupportedLocale)) {
    return value as SupportedLocale;
  }

  return 'en';
};

export const getInitialLocale = (): SupportedLocale => {
  if (typeof window === 'undefined') return 'en';

  try {
    const raw = localStorage.getItem('language');
    const normalized = normalizeLocale(raw);

    if (raw !== normalized) {
      localStorage.setItem('language', normalized);
    }

    return normalized;
  } catch {
    return 'en';
  }
};

export const i18n = createI18n({
  locale: getInitialLocale(),
  messages: messages,
  silentTranslationWarn: true,
  legacy: false,
  silentFallbackWarn: true,
});
